module.exports = __webpack_public_path__ + "static/img/banner_about.7f11d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_about.jpg
// module id = I2fc
// module chunks = 1